import React, {
      useState,
      forwardRef,
      useImperativeHandle
    } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

const AlertToast = forwardRef((props, ref) => {

  const [show, setShow] = useState(false);
  const [options, setOptions] = useState({});

  const onCloseHandle = () => {
    setShow(false);
  }  
   
  useImperativeHandle(ref, () => ({
  
    showAlert(options) {
      setOptions(options);
      setShow(true);  
    },
  }));

  return (
    <>
      <ToastContainer className="position-fixed p-3 top-0 end-0">
        <Toast className={'d-flex text-bg-'+options?.bg} onClose={onCloseHandle} show={show} delay={3000} autohide>
          <div className="d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="ms-3 m-auto" viewBox="0 0 16 16">
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
          </svg>
          <Toast.Body>{options?.text}</Toast.Body>
          </div>
          <button type="button" className="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close" onClick={() => setShow(false)}></button>
        </Toast>
      </ToastContainer>
    </>
  );
})

export default AlertToast;